export default __webpack_public_path__ + "assets/cheetah.246556.png";